import { combineReducers } from 'redux';

import appReducer, { IAppReducerState } from './appReducer';

export interface IApplicationState {
    appReducer: IAppReducerState;
}

export default combineReducers<IApplicationState>({
    appReducer
});
